import styled from "styled-components";

export const ActivityCertificateFormStyled = styled.div`
  .input_wrap {
    margin-bottom: 16px;
  }
  .btn_wrap {
    margin-top: 24px;
  }
`;
